<div class="container-panel">
  <h4>
    {{ 'Doc::SupplierQuote:Address' | abpLocalization }}
  </h4>
  <div class="card-group header card-col mb-3 mt-2">
    <div class="w-100">
      <dw-core-address-detail
        [formGroup]="deliveryAddressControl"
        [mapTypeId]="mapTypeId"
        #addressDetail
        [isMapVisible]="false"
        [canToggleMapVisibility]="true"
        [showSearch]="showSearch"
      >
        <div class="row" before-search>
          <div class="col">
            <label for="deliveryAddress_ThirdPartyAddressId" class="form-label text-primary">
              {{ 'Doc::SupplierQuote:Address' | abpLocalization }}
            </label>
            <ng-select
              class="form-control"
              id="deliveryAddress_ThirdPartyAddressId"
              formControlName="thirdPartyAddressId"
              bindLabel="name"
              bindValue="id"
              [items]="addresses$ | async"
              [readonly]="docForm.get('thirdPartyId').value == null"
            >
            </ng-select>
          </div>
        </div>
        <div class="row">
          <div class="col" before-country>
            <label for="address2" class="text-primary">{{
              'Contact::Address:Address2' | abpLocalization
            }}</label>
            <input type="text" id="address2" class="form-control" formControlName="address2" />
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label for="deliveryAddress_ContactInfo" class="form-label text-primary">
              {{ 'Doc::Address:ContactInfo' | abpLocalization }}
            </label>
            <input
              type="text"
              class="form-control"
              id="deliveryAddress_ContactInfo"
              formControlName="contactInfo"
            />
          </div>
        </div>
      </dw-core-address-detail>
    </div>
  </div>
</div>
